/*
 * Verhalten (HUB, ADR 0022) — eigener Tracker für happy-snus.de.
 *
 * Meldet an das Hub (hub.better-elements.de), was Besucher tun: Seitenaufrufe (mit Herkunft beim Einstieg), Klicks auf
 * Bedienelemente, Wut- und tote Klicks, Scrolltiefe, aktive Zeit, Warenkorb und den Klick zur Kasse. Erst nach Einwilligung
 * (Shopify Customer Privacy API: Analyse erlaubt); beim Widerruf hört es auf und löscht seine IDs.
 *
 * Nie gemeldet: Eingaben in Formularen, der Suchteil der Adresse (nur der Pfad), Cookies. Besucher und Sitzung sind
 * Zufalls-IDs im localStorage; eine Sitzung endet nach 30 Minuten ohne Ereignis.
 *
 * An und aus je Shop über das Shop-Metafeld hub.verhalten (scripts/verhalten.py an|aus), eingebunden über
 * snippets/hs-verhalten.liquid. Die vier Shops haben je eine eigene Datei mit eigenem Präfix (CLAUDE.md).
 */
(function () {
  'use strict';
  var konfigEl = document.getElementById('hs-verhalten-daten');
  if (!konfigEl || window.__hsVerhalten) return;
  window.__hsVerhalten = true;
  var K;
  try { K = JSON.parse(konfigEl.textContent); } catch (e) { return; }
  if (navigator.webdriver || /bot\b|bot\/|crawl|spider|slurp|lighthouse|headless|pagespeed|gtmetrix|pingdom/i.test(navigator.userAgent || '')) return;

  var SITZUNG_MS = 30 * 60 * 1000;
  var AKTIV_NACH_MS = 15000;
  var SENDEN_NACH_MS = 10000;
  var B_KEY = 'hub-verhalten-b';
  var S_KEY = 'hub-verhalten-s';
  // Bedienelemente; was davon getroffen wird, beschreibt den Klick
  var INTERAKTIV = 'a,button,[role="button"],[role="link"],[role="tab"],[role="menuitem"],[role="option"],input[type="submit"],input[type="button"],input[type="checkbox"],input[type="radio"],summary,label,select';
  // Wege zur Kasse in diesem Theme
  var KASSE = "a[href*=\"/checkout\"],[name=\"checkout\"],#checkout,button[formaction*=\"checkout\"]";
  var KONTO = /^customers\//.test(K.typ || '');

  var an = false;
  var besucher = null;
  var sitzung = null;
  var neu = false;
  var seite = uuid();
  var schlange = [];
  var uhr = null;
  var tiefeMax = 0;
  var aktivMs = 0;
  var aktivGemeldet = 0;
  var aktivBis = Date.now() + AKTIV_NACH_MS;
  var letzterTakt = Date.now();
  var takt = null;
  var letzterKorb = 0;
  var letzteKasse = 0;
  var tiefeGemeldet = -1;
  var klicks = [];

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16);
    crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function lies(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function schreib(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* privater Modus: IDs gelten nur für diese Seite */ } }

  function ids() {
    var jetzt = Date.now();
    var b = lies(B_KEY);
    if (!b || typeof b.id !== 'string') { b = { id: uuid() }; neu = true; schreib(B_KEY, b); }
    var s = lies(S_KEY);
    if (!s || typeof s.id !== 'string' || !(jetzt - s.zuletzt < SITZUNG_MS)) s = { id: uuid(), zuletzt: jetzt };
    s.zuletzt = jetzt;
    schreib(S_KEY, s);
    besucher = b.id;
    sitzung = s.id;
  }

  // Horizon 4 scrollt über .page-wrapper, nicht über das Fenster
  function scrollStand() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 10 && /auto|scroll/.test(getComputedStyle(w).overflowY)) return { oben: w.scrollTop, sicht: w.clientHeight, hoehe: w.scrollHeight };
    var d = document.documentElement;
    return { oben: window.scrollY || d.scrollTop, sicht: window.innerHeight, hoehe: Math.max(d.scrollHeight, document.body ? document.body.scrollHeight : 0) };
  }
  function messeTiefe() {
    var s = scrollStand();
    var p = s.hoehe > 0 ? Math.min(100, Math.round(((s.oben + s.sicht) / s.hoehe) * 100)) : 100;
    if (p > tiefeMax) tiefeMax = p;
  }

  function melde(e) {
    if (!an) return;
    e.t = Date.now();
    if (!e.pfad) e.pfad = location.pathname;
    if (K.typ) e.typ = K.typ;
    schlange.push(e);
    if (schlange.length >= 20) senden();
    else if (!uhr) uhr = setTimeout(senden, SENDEN_NACH_MS);
  }

  function senden() {
    clearTimeout(uhr);
    uhr = null;
    if (!an || !schlange.length) return;
    var jetzt = Date.now();
    var s = lies(S_KEY);
    if (s && s.id === sitzung) { s.zuletzt = jetzt; schreib(S_KEY, s); }
    var e = schlange.splice(0, 20).map(function (x) {
      var y = {};
      for (var k in x) if (k !== 't' && x[k] !== undefined) y[k] = x[k];
      y.alter = Math.max(0, jetzt - x.t);
      return y;
    });
    var body = JSON.stringify({ v: 1, shop: K.shop, b: besucher, s: sitzung, e: e });
    var ok = false;
    try { ok = !!(navigator.sendBeacon && navigator.sendBeacon(K.ziel, new Blob([body], { type: 'text/plain' }))); } catch (err) { ok = false; }
    if (!ok) {
      try { fetch(K.ziel, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' } }); } catch (err) { /* nichts zu tun */ }
    }
    if (schlange.length) senden();
  }

  // Verlassen oder verstecken (Tab-Wechsel): beides kommt oft direkt nacheinander — gemeldet wird nur, was sich geändert hat
  function ende() {
    if (!an) return;
    messeTiefe();
    if (aktivMs > aktivGemeldet || tiefeMax > tiefeGemeldet) {
      melde({ a: 'ende', seite: seite, tiefe: tiefeMax, aktiv: aktivMs - aktivGemeldet });
      aktivGemeldet = aktivMs;
      tiefeGemeldet = tiefeMax;
    }
    senden();
  }

  // Der Kassenknopf ist oft ein Absenden-Knopf: Klick und Absenden kommen beide an, gezählt wird einmal
  function kasse() {
    if (Date.now() - letzteKasse < 2000) return;
    letzteKasse = Date.now();
    melde({ a: 'kasse' });
    senden();
  }

  function seitenaufruf() {
    var q = new URLSearchParams(location.search);
    var utm = {};
    if (q.get('utm_source')) utm.quelle = q.get('utm_source');
    if (q.get('utm_medium')) utm.medium = q.get('utm_medium');
    if (q.get('utm_campaign')) utm.kampagne = q.get('utm_campaign');
    var klickid = q.get('gclid') || q.get('gbraid') || q.get('wbraid') ? 'google' : q.get('fbclid') ? 'meta' : q.get('msclkid') ? 'microsoft' : q.get('ttclid') ? 'tiktok' : undefined;
    var ref;
    try { if (document.referrer) { var r = new URL(document.referrer); if (r.host !== location.host) ref = r.host; } } catch (e) { ref = undefined; }
    melde({
      a: 'seite', seite: seite, ref: ref, utm: utm, klickid: klickid,
      produkt: K.produkt ? String(K.produkt) : undefined, kollektion: K.kollektion || undefined, suche: K.suche || undefined,
      breite: window.innerWidth, sprache: K.sprache || undefined, markt: K.markt || undefined, angemeldet: !!K.angemeldet, neu: neu,
    });
  }

  function beschreibe(el) {
    var t = el.tagName.toLowerCase();
    if (el.id && !/\d{3,}|__|--/.test(el.id)) return (t + '#' + el.id).slice(0, 120);
    var name = el.getAttribute('name');
    if (name && /^[\w-]{1,30}$/.test(name)) t += '[name=' + name + ']';
    var klassen = (el.getAttribute('class') || '').split(/\s+/).filter(function (c) {
      return c && !/\d{3,}|^(is|has)-|active|open|hidden|visible|loading|selected|focus|hover/i.test(c);
    }).slice(0, 2);
    if (klassen.length) t += '.' + klassen.join('.');
    return t.slice(0, 120);
  }
  function bereich(el) {
    var s = el.closest('.shopify-section');
    if (!s || !s.id) return undefined;
    var teile = s.id.replace(/^shopify-section-/, '').split('__');
    return (teile[1] || teile[0]).replace(/_[A-Za-z0-9]{6}$/, '').slice(0, 60);
  }
  function beschriftung(z) {
    if (KONTO) return undefined;
    var tag = z.tagName;
    if (tag === 'SELECT' || (tag === 'INPUT' && !/^(submit|button)$/i.test(z.type))) return undefined;
    var t = z.getAttribute('aria-label') || z.getAttribute('title') || (tag === 'INPUT' ? z.value : z.innerText) || '';
    if (!t.trim()) { var img = z.querySelector && z.querySelector('img[alt]'); if (img) t = img.alt; }
    t = t.replace(/\s+/g, ' ').trim();
    return t ? t.slice(0, 60) : undefined;
  }
  function linkZiel(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (u.protocol === 'mailto:' || u.protocol === 'tel:') return u.protocol;
      return u.host === location.host ? u.pathname : u.host;
    } catch (e) { return undefined; }
  }
  // Tot: kein Bedienelement, kein Zeiger, kein Text zum Markieren und keine Fläche, die etwas schließt
  function istTot(el) {
    if (el === document.documentElement || el === document.body) return false;
    var c = getComputedStyle(el).cursor;
    if (/pointer|zoom|grab|text|move/.test(c)) return false;
    for (var n = el, i = 0; n && n !== document.body && i < 4; n = n.parentElement, i++) {
      if (/overlay|backdrop|scrim|modal|drawer|dialog/i.test((n.getAttribute('class') || '') + ' ' + n.tagName)) return false;
    }
    return true;
  }

  function klick(ev) {
    if (!an) return;
    var t = ev.target;
    if (!t || !t.closest) return;
    var ziel = t.closest(INTERAKTIV);
    var el = ziel || t;
    var jetzt = Date.now();
    klicks = klicks.filter(function (k) { return jetzt - k.t < 1000; });
    var nah = klicks.filter(function (k) { return Math.abs(k.x - ev.clientX) < 30 && Math.abs(k.y - ev.clientY) < 30; }).length;
    klicks.push({ t: jetzt, x: ev.clientX, y: ev.clientY });
    // Auf den leeren Hintergrund: nur als Wutklick von Belang
    if (!ziel && (t === document.documentElement || t === document.body) && nah !== 2) return;
    var s = scrollStand();
    var e = {
      a: 'klick', seite: seite, ziel: beschreibe(el), bereich: bereich(el),
      x: Math.round((ev.clientX / Math.max(1, window.innerWidth)) * 1000), y: Math.round(ev.clientY + s.oben), hoehe: Math.round(s.hoehe),
    };
    if (ziel) {
      e.text = beschriftung(ziel);
      if (ziel.tagName === 'A' && ziel.getAttribute('href')) e.href = linkZiel(ziel);
    } else if (istTot(t)) e.tot = true;
    if (nah === 2) e.wut = true;
    melde(e);
    if (ziel && ziel.matches(KASSE)) kasse();
  }

  function absenden(ev) {
    if (!an) return;
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    var aktion = f.getAttribute('action') || '';
    if (/\/cart\/add/.test(aktion)) {
      var v = f.querySelector('[name="id"]');
      var m = f.querySelector('[name="quantity"]');
      var p = f.querySelector('[name="product-id"]');
      letzterKorb = Date.now();
      melde({ a: 'warenkorb', produkt: p && p.value ? p.value : K.produkt ? String(K.produkt) : undefined, variante: v ? v.value : undefined, menge: m ? Number(m.value) || 1 : 1, quelle: 'formular' });
      return;
    }
    var knopf = ev.submitter;
    if ((knopf && knopf.matches && knopf.matches(KASSE)) || /\/checkout/.test(aktion)) { kasse(); return; }
    var art = f.querySelector('[name="form_type"]');
    var typ = art ? art.value : '';
    if (typ === 'customer') melde({ a: 'formular', art: 'newsletter' });
    else if (typ === 'contact') melde({ a: 'formular', art: 'kontakt' });
    else if (typ === 'customer_login' || typ === 'create_customer') melde({ a: 'formular', art: 'konto' });
  }

  // Warenkörbe, die per fetch gelegt werden (Schnellkauf, eigene Formulare): nur die Adresse wird gesehen, nichts daran geändert
  function beobachteNetz() {
    try {
      new PerformanceObserver(function (liste) {
        liste.getEntries().forEach(function (e) {
          if ((e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest') && /\/cart\/add(\.js)?(\?|$)/.test(e.name) && Date.now() - letzterKorb > 3000) {
            letzterKorb = Date.now();
            melde({ a: 'warenkorb', produkt: K.produkt ? String(K.produkt) : undefined, quelle: 'netz' });
          }
        });
      }).observe({ type: 'resource' });
    } catch (e) { /* ohne PerformanceObserver nur Formulare */ }
  }

  function aktiv() { aktivBis = Date.now() + AKTIV_NACH_MS; }

  var verdrahtet = false;
  function starten() {
    an = true;
    ids();
    seitenaufruf();
    messeTiefe();
    if (verdrahtet) return;
    verdrahtet = true;
    document.addEventListener('click', klick, true);
    document.addEventListener('submit', absenden, true);
    // capture: auch das Scrollen eines Containers (page-wrapper) kommt hier an
    var wartet = false;
    document.addEventListener('scroll', function () {
      aktiv();
      if (wartet) return;
      wartet = true;
      setTimeout(function () { wartet = false; messeTiefe(); }, 250);
    }, { capture: true, passive: true });
    ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'].forEach(function (n) { document.addEventListener(n, aktiv, { capture: true, passive: true }); });
    takt = setInterval(function () {
      var j = Date.now();
      if (an && document.visibilityState === 'visible' && j < aktivBis) aktivMs += Math.min(j - letzterTakt, 2000);
      letzterTakt = j;
    }, 1000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') ende();
      else { letzterTakt = Date.now(); aktiv(); }
    });
    window.addEventListener('pagehide', ende);
    beobachteNetz();
  }

  function stoppen() {
    an = false;
    schlange = [];
    clearTimeout(uhr);
    uhr = null;
    try { localStorage.removeItem(B_KEY); localStorage.removeItem(S_KEY); } catch (e) { /* nichts gespeichert */ }
  }

  function erlaubt() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed());
  }
  function pruefen() {
    if (erlaubt()) { if (!an) starten(); } else if (an) stoppen();
  }

  function los() {
    document.addEventListener('visitorConsentCollected', function () { setTimeout(pruefen, 0); });
    if (window.Shopify && window.Shopify.customerPrivacy) return pruefen();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) { if (!fehler) pruefen(); });
    }
  }

  // Nach dem Aufbau der Seite, wenn der Browser Luft hat — gesendet wird ohnehin erst nach zehn Sekunden oder beim Verlassen
  if (window.requestIdleCallback) requestIdleCallback(los, { timeout: 2000 });
  else setTimeout(los, 300);
})();
